module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"logout":"Logout"},"fi":{"logout":"Kirjaudu ulos"},"sv":{"logout":"Logga ut"},"de":{"logout":"Ausloggen"},"ko":{"logout":"로그아웃"}}')
  delete Component.options._Ctor
}
